import React from 'react';

const OrderStatusBadge = ({ status, compact = false }) => {
  const statusConfig = {
    pending: {
      label: 'Pending',
      className: 'bg-warning/10 text-warning border-warning/20'
    },
    processing: {
      label: 'Processing',
      className: 'bg-blue-500/10 text-blue-500 border-blue-500/20'
    },
    readyforpickup: {
      label: 'Ready for Pickup',
      className: 'bg-purple-500/10 text-purple-500 border-purple-500/20'
    },
    completed: {
      label: 'Completed',
      className: 'bg-success/10 text-success border-success/20'
    },
    cancelled: {
      label: 'Cancelled',
      className: 'bg-error/10 text-error border-error/20'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.pending;
  return (
    <span
      className={`inline-flex items-center rounded-full border font-caption font-medium ${compact ? 'px-2 py-0.5 text-[10px]' : 'px-3 py-1 text-xs'} ${config?.className}`}
    >
      {config?.label}
    </span>
  );
};

export default OrderStatusBadge;
